module.exports = __webpack_public_path__ + "img/Property 1=icon013.b1869910.svg";